export const nodeEnv = process.env.NODE_ENV;

export const cdnUrl = process.env.GATSBY_CDN_URL;
export const baseUrl = process.env.GATSBY_API_URL;

export const postHogKey = process.env.GATSBY_POSTHOG_KEY as string;
export const postHogHost = process.env.GATSBY_POSTHOG_HOST;
